import { useState, useEffect, useCallback } from 'react';
import type { Evento } from '../types/evento';
import { eventService } from '../services/domain/eventService';

interface UseEventoResult {
  data: Evento[];
  loading: boolean;
  error: string | null;
  total: number;
  totalPages: number;
  refetch: () => void;
  updating: boolean;
  creating: boolean;
  searching: boolean;
}

interface EventoParams {
  page?: number;
  name_persona?: string;
  pageSize?: number,
}

export const useEvento = (params: EventoParams): UseEventoResult => {
  const [data, setData] = useState<Evento[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [updating] = useState(false);
  const [creating] = useState(false);
  const [searching] = useState(false);

  const fetchEvento = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await eventService.getEvents();
      setData(response.data);
      setTotal(response.pagination.totalItems);
      setTotalPages(response.pagination.totalPages);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Error desconocido';
      setError(errorMessage);
      console.error('Error fetching empleados:', err);
    } finally {
      setLoading(false);
    }
  }, [params.page, params.name_persona]);

  useEffect(() => {
    fetchEvento();
  }, [fetchEvento]);

  const refetch = useCallback(async () => {
    try {
      // const syncFacialResult = await personService.syncFacial('1');
      // if (!syncFacialResult) {
      //   throw new Error('Error al actualizar facial');
      // }
      fetchEvento();
    }
    catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Error en actualizar';
      setError(errorMessage);
    }
  }, [fetchEvento]);


  return {
    data,
    loading,
    error,
    total,
    totalPages,
    refetch,
    updating,
    creating,
    searching
  };
};